import containerQueries from '@tailwindcss/container-queries';

export default {
    theme: {
        colors: {
            marble: '#ede6de',
            'marble-darker': '#e6ddd3',
            'marble-darkest': '#d6c9bd',
            'smoke-ring-on-charcoal': '#dc736f',
            'smoke-ring-lighter': '#d34f4a',
            'smoke-ring': '#d0433e',
            'smoke-ring-on-marble': '#bd332e',
            'burnt-ends': '#622128',
            'burnt-ends-darker': '#4f1b21',
            'stainless-steel': '#c8c9c7',
            smoke: '#75787b',
            'thin-lines': '#3c3c3c',
            charcoal: '#2d2926',
            'black-lighter': '#0d0c0b',
            black: '#000000',
            white: '#ffffff',
        },
    },
    plugins: [
        containerQueries,
    ],
};

